import React from 'react'
import Img1 from '../../images/IMG_3676.jpg'
import Img2 from '../../images/IMG_36642.jpg'
import Img3 from '../../images/RnD.jpeg'
import SimpleImageSlider from 'react-simple-image-slider'
import ImageSlider from '../../components/ImageSlider'
import Dev from '../../images/dev.png'
import AnimatedElement from '../../components/AnimatedElement'
import TransitionPage from '../../TransitionPage'
import Radio from '../../images/radio-waves.png'
import Digital from '../../images/frequency.png'
import Processing from '../../images/iteration.png'
import AI from '../../images/microchip.png'
import RNDi from '../../images/rnd.png'
import BG from '../../components/SVG/BG'
import { animate, motion } from 'framer-motion'
import RevealText from '../../components/TextReveal2'
import ViewElement from '../../components/ViewElement'

function RND() {
    const images = [
        Img1,
        Img2,
        Img3
    ]
    return (
        <TransitionPage>

            <div className='relative flex flex-col  items-center bg-gray-100 overflow-hidden'>
              
                <div className='flex items-center justify-center h-full'>
                    <div className='bg-black bg-opacity-10'>
                        <img className=' mix-blend-multiply' src={Img3} />
                    </div>
                    <div className='absolute'>
                        <RevealText text='Research & Development' css='uppercase max-sm:text-[1.3rem] bg-[#000] after:bg-black p-3 bg-opacity-60 text-[3rem] font-bold text-white' />
                    </div>
                </div>


                <div className='flex flex-col px-[10%] max-sm:px-3  gap-5 mt-10 relative items-center justify-center'>
                   <RevealText text='Transforming Ideas into Reality' css='text-[3rem] max-sm:text-[1rem] text-[#425472] after:bg-[#425472] uppercase font-bold' />
                    <AnimatedElement direction='from-down' >

                        <div className=' text-black flex max-sm:flex-col items-center justify-center'>
                            <p className='text-justify flex-[2]'>
                                <RevealText text='The Research and Development' css='text-[2rem] after:bg-black max-sm:text-[1.2rem] font-bold uppercase' />
                                <span>

                                    (R&D) is the pulsating heart of our company's innovation engine. Situated at the forefront of technological
                                    advancement, our R&D department embodies our commitment to pushing boundaries, exploring new horizons, and staying ahead of the
                                    curve in a rapidly evolving industry landscape.

                                </span>
                            </p>

                            <div className='flex-1'>
                                <motion.img alt='analog' src={RNDi} />
                            </div>
                        </div>
                    </AnimatedElement>
                    <AnimatedElement direction='from-left'>
                        <div className='mb-10 max-sm:mt-4'>
                            <RevealText text='Strengths of R&D' css='text-[3rem] max-sm:text-[1.8rem] after:bg-[#425472] text-[#425472] uppercase font-bold' />
                            <div className='flex max-sm:flex-col gap-3 mt-6'>
                                <AnimatedElement direction='from-down' delayAn=''>

                                    <div className=' p-3 bg-gray-200 flex flex-col gap-3 shadow-md items-center font-semibold'><img alt='analog' width={100} src={Radio} />Analog and RF designing</div>
                                </AnimatedElement>
                                <AnimatedElement direction='from-down' delayAn='0.13'>
                                    <div className=' p-3 bg-gray-200 flex flex-col gap-3 shadow-md items-center font-semibold'><img alt='digital' width={100} src={Digital} />Digital and Mixed Signal designing</div>
                                </AnimatedElement>
                                <AnimatedElement direction='from-down' delayAn='0.16'>

                                    <div className=' p-3 bg-gray-200 flex flex-col gap-3 shadow-md items-center font-semibold'><img alt='process' width={100} src={Processing} />Analog and Digital signal processing</div>
                                </AnimatedElement>
                                <AnimatedElement direction='from-down' delayAn='0.19'>

                                    <div className=' p-3 bg-gray-200 flex flex-col gap-3 shadow-md items-center font-semibold'><img alt='ai' className='-rotate-90' width={100} src={AI} />Power Electronics and AI Algorithms</div>
                                </AnimatedElement>
                            </div>
                        </div>
                    </AnimatedElement>
                </div>

            </div >
        </TransitionPage >
    )
}

export default RND